import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Variables/Global";
import axiosInstance from '../../../api/axiosConfig';

const ManagePosition = () => {
    var pId = useParams();
    var navigate = useNavigate();
     
    const [pageType, setPageType] = useState("Add");
    const [positionName, setPositionName] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [companies, setCompanies] = useState([]);

    const GetPosition = (positionId) => {
        var config = {
            method: 'get',
            url: "Position/GetPositions/" + positionId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setPositionName(response.data.name)
                setCompanyId(response.data.companyId)
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    const submitForm = (e) => {
        e.preventDefault();
        if (IsValid()) {
            const body = { positionName: positionName, companyId: companyId, userId: localStorage.getItem("uTsReD") }
            if (pId.PositionId == "0") { //Add Product Size
                var config = {
                    method: 'post',
                    url: "Position/AddPosition",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if (response.status === 200) {
                            toast.success("Position Added Successfully")
                            navigate("/HR/Positions")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
            else { // Update Product Size
                var config = {
                    method: 'put',
                    url: "Position/EditPosition/" + pId.PositionId,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if (response.status === 200) {
                            toast.success("Position Updated Successfully")
                            navigate("/HR/Positions")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
        }
    }

    const IsValid = () => {
        if (positionName == "" && companyId == "0") {
            toast.error("Enter all required fields");
            return false;
        }
        else if (positionName == "") {
            toast.error("Enter Position Name");
            return false;
        }
        else if (companyId == "0") {
            toast.error("Select Company");
            return false;
        }
        return true;
    }

    useEffect(() => {
        // GetCompanies();
        document.title = "Positions";
        if (pId.PositionId !== "0") {
            setPageType("Edit");
            GetPosition(pId.PositionId)
        }
    }, [])
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Positions</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/Settings/Size">Positions</Link></li>
                                    <li className="breadcrumb-item active">{pageType} Position</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-3 row">
                                        <div className="col-12 col-md-6">
                                            <h4 className="card-title">{pageType} Position</h4>
                                        </div>
                                        <div className="col-12 col-md-6 text-right">
                                            <Link to="/HR/Positions" className="btn btn-secondary mr-3">Cancel</Link>
                                            <button className="btn btn-primary" onClick={(e) => submitForm(e)}>Submit</button>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label htmlFor="txtPositionName" className="col-md-12 col-form-label">Position Name</label>
                                            <input className="form-control" type="text" value={positionName} id="txtPositionName" onChange={(e) => setPositionName(e.target.value)} required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="col-md-12 col-form-label">Company</label>
                                            <select className="form-control" value={companyId} onChange={(e) => setCompanyId(e.target.value)} required>
                                                <option value="0" key="0">-- Select Company Name --</option>
                                                {companies.length > 0 && (
                                                    companies.map((c, index) => {
                                                        return (<>
                                                            <option value={c.companyId} key={index}>{c.companyName}</option>
                                                        </>)
                                                    })
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default ManagePosition;